import {
    createElementVNode as _$ce,
    createUnknownComponentVNode as _$cc,
    extend as _$ex,
    EMPTY_OBJ as _$em,
} from 'intact';
import {Bubble, FileCardList, FileCard} from 'kpc';


export default function($props, $blocks, $__proto__) {
    $blocks || ($blocks = {});
    $props || ($props = {});
    var $this = this;
    
    return _$ce(2, 'div', [
        _$cc(Bubble, {
            'avatar': true,
            'roleName': '你',
            'placement': 'end',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['attachments'] = function($super) {
                            return (
                                _$cc(FileCardList, {
                                    'overflow': 'scrollX',
                                    'items': this.get('userFiles')
                                })
                            );
                        }),
                        (__$blocks['attachments'] = function($super, data) {
                            var block = $blocks['attachments'];
                            var callBlock = function() {
                                return _$blocks['attachments'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    (
                        (_$blocks['content'] = function($super) {
                            return '\n            请基于这些输入素材做一个 20 秒的介绍短片。\n        ';
                        }),
                        (__$blocks['content'] = function($super, data) {
                            var block = $blocks['content'];
                            var callBlock = function() {
                                return _$blocks['content'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        }),
        _$cc(Bubble, {
            'avatar': true,
            'roleName': 'AI 助手',
            'variant': 'plain',
            '$blocks': function($blocks) {
                var _$blocks = {}, __$blocks = _$ex({}, $blocks);
                return (
                    (
                        (_$blocks['attachments'] = function($super) {
                            return (
                                _$cc(FileCard, {
                                    'name': 'intro.mp4',
                                    'src': 'https://interactive-examples.mdn.mozilla.net/media/cc0-videos/flower.mp4',
                                    'poster': 'https://images.unsplash.com/photo-1492691527719-9d1e07e534b4?auto=format&fit=crop&w=1200&q=80',
                                    'byte': 1024 * 1024 * 18,
                                    'videoProps': {muted: true, playsinline: true},
                                    'size': 'large'
                                })
                            );
                        }),
                        (__$blocks['attachments'] = function($super, data) {
                            var block = $blocks['attachments'];
                            var callBlock = function() {
                                return _$blocks['attachments'].call($this, $super, data);
                            };
                            return block ?
                                block.call($this, callBlock, data) :
                                callBlock();
                        })
                    ),
                    __$blocks
                );
            }.call($this, _$em)
        })
    ], 4, 'bubble-demo-attachments');
};